import React from 'react';
import { Header } from '../../features/header/Header';
import styled from 'styled-components';

import { Container, Table } from 'reactstrap';

const FieldName = styled.th`
  width: 25%;
`;

function BepFieldSpecPage() {
  return (
    <>
      <Header />
      <Container>
        <h2 className="mb-4">Bonds Upload File Format</h2>
        <p>
          Trades should be uploaded in comma-delimited csv files with all
          timestamps in ISO 8601 Date and Time format.
        </p>
        <p>
          Field names including a / indicate that there are multiple accepted
          names for the given field.
        </p>
        <h3 className="mb-4">Required Fields</h3>
        <Table>
          <thead>
            <tr>
              <FieldName>Field Name</FieldName>
              <th>Alternative Field Names</th>
              <th>Examples</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Identifier_Type</td>
              <td>SecurityIDType, InstrumentIDType</td>
              <td>ISIN, CUSIP</td>
            </tr>
            <tr>
              <td>Identifier</td>
              <td>SecurityID, InstrumentID</td>
              <td>XS1472483772, US92857WBJ80</td>
            </tr>
            <tr>
              <td>Trade_DateTime</td>
              <td>TradeDate. TradeTime, ExecutionDate, ExecutionTime</td>
              <td>2015-08-29T11:22:09.815479+01:00</td>
            </tr>
            <tr>
              <td>Trade_Price</td>
              <td>Price, ExecutionPrice</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Side</td>
              <td>Side_String, SideStr</td>
              <td>B, S, Buy, Sell</td>
            </tr>
            <tr>
              <td>Notional_Traded</td>
              <td>Amount, TradeAmount, Volume, Notional, NotionalTraded</td>
              <td>2500000</td>
            </tr>
          </tbody>
        </Table>
        <h3 className="mb-4">Optional Fields</h3>
        <Table>
          <thead>
            <tr>
              <FieldName>Field Name</FieldName>
              <th>Alternative Field Names</th>
              <th>Examples</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Order_Id</td>
              <td>OrderID</td>
              <td>1234567, A1B2C3</td>
            </tr>
            <tr>
              <td>Trade_Id</td>
              <td>Execution_ID, Deal_ID</td>
              <td>7654321, Z9Y8X7</td>
            </tr>
            <tr>
              <td>Portfolio_Id</td>
              <td>Portfolio, PortfolioID</td>
              <td>EU122480, EM011521</td>
            </tr>
            <tr>
              <td>Other_1</td>
              <td>Other, Other1</td>
              <td>A12345</td>
            </tr>
            <tr>
              <td>Order_DateTime</td>
              <td>Order_Date, Order_Time, Order_Date_Time</td>
              <td>2015-08-29T11:22:09.815479+01:00</td>
            </tr>
            <tr>
              <td>Order_Type</td>
              <td>OrderType</td>
              <td>Market, Discretionary</td>
            </tr>
            <tr>
              <td>Trade_Type</td>
              <td>TradeType</td>
              <td>Electronic, Voice</td>
            </tr>
            <tr>
              <td>Explicit_Cost</td>
              <td>Comission, Fee, Tax</td>
              <td>3.75, 0.25</td>
            </tr>
            <tr>
              <td>Security_Type</td>
              <td>SecurityType</td>
              <td>
                Corporate Bond, Agency Bond, Government Bond, U.S. Treasury bill
                (UTB)
              </td>
            </tr>
            <tr>
              <td>Instrument_Type</td>
              <td>InstrumentType</td>
              <td>
                Corporate Bond, Agency Bond, Government Bond, U.S. Treasury bill
                (UTB)
              </td>
            </tr>
            <tr>
              <td>Security_Sub_Type</td>
              <td>SecuritySubType, Security_SubType</td>
              <td>US HG, US HY, EUR Euro, GBP Euro, EM USD, EM Local</td>
            </tr>
            <tr>
              <td>Description</td>
              <td> Desc </td>
              <td>
                BACR 4.836 05/09/28, 10YR Treasury Note 1.75% 2029-11-15, UKT
                0.625 06/25
              </td>
            </tr>
            <tr>
              <td>Currency</td>
              <td>Curr, Cur, Ccy</td>
              <td>Agency, Principal, Match Principal</td>
            </tr>
            <tr>
              <td>Trade_Capacity</td>
              <td>TradeCapacity</td>
              <td>Agency, Principal, Match Principal</td>
            </tr>
            <tr>
              <td>Trader</td>
              <td>TraderName, TraderID, TraderCode</td>
              <td>JSMITH, E2468</td>
            </tr>
            <tr>
              <td>PM</td>
              <td>PortfolioManager </td>
              <td>MPETER, EM623D</td>
            </tr>
            <tr>
              <td>Trade_Desk</td>
              <td>Desk, TradeDesk</td>
              <td>NYC, LON</td>
            </tr>
            <tr>
              <td>Desk_Location</td>
              <td>Location, DeskLocation</td>
              <td>NYC, LON</td>
            </tr>
            <tr>
              <td>Dealer</td>
              <td>DealerName, DealerID, DealerCode</td>
              <td>GS, JPM, TPICAP</td>
            </tr>
            <tr>
              <td>Broker</td>
              <td>BrokerName, BrokerID, BrokerCode</td>
              <td>GS, JPM, TPICAP</td>
            </tr>
            <tr>
              <td>Platform</td>
              <td>Platform_Name</td>
              <td>Bloomberg, TW, MKTX</td>
            </tr>
            <tr>
              <td>Venue</td>
              <td>TradingVenue, TradeVenue</td>
              <td>Bloomberg, TW, MKTX</td>
            </tr>
            <tr>
              <td>Cover_Price</td>
              <td>CoverPrice</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Limit_Price</td>
              <td>LimitPrice</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Event_Type</td>
              <td>EventType</td>
              <td>Rebalance, News, Announcement, Interest Rates</td>
            </tr>
            <tr>
              <td>Instructions</td>
              <td>Instructions</td>
              <td>Discretion, Market</td>
            </tr>
            <tr>
              <td>Legal_Entity</td>
              <td>Entity, ENTITY, LEGAL_ENTITY</td>
              <td>Client-specific codes (e.g. LE_1, LE_2)</td>
            </tr>
            <tr>
              <td>Status</td>
              <td>TradeStatus, Trade_Status</td>
              <td>Live, Closed</td>
            </tr>
            <tr>
              <td>Account</td>
              <td>AccountName, Account_Name</td>
              <td>ABC, 123</td>
            </tr>
            <tr>
              <td>Fund</td>
              <td>FundType, Fund_Type</td>
              <td>Flagship, XYZ</td>
            </tr>
            <tr>
              <td>Strategy</td>
              <td>StrategyType</td>
              <td>Active, Passive</td>
            </tr>
            <tr>
              <td>Custom_Benchmark_1</td>
              <td>CustomBenchmark1, Custom_Benchmark1</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Custom_Benchmark_2</td>
              <td>CustomBenchmark2, CustomBenchmark_2</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Custom_Benchmark_3</td>
              <td>CustomBenchmark3, Custom_Benchmark3</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Custom_Benchmark_4</td>
              <td>CustomBenchmark4, CustomBenchmark_4</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Custom_1</td>
              <td>Custom_1</td>
              <td>2022-01-10, 2023-3-5</td>
            </tr>
            <tr>
              <td>Custom_2</td>
              <td>Custom_2</td>
              <td>2021-09-01T05:31:00Z</td>
            </tr>
            <tr>
              <td>Custom_3</td>
              <td>Custom_3</td>
              <td>Notes, Extra information</td>
            </tr>
          </tbody>
        </Table>
        <br></br>
        <br></br>
        <br></br>
      </Container>
    </>
  );
}

export default BepFieldSpecPage;
